import { Box, Grid, Typography, Button } from '@mui/material';
import { AppIcon } from '../../components/app-icon/AppIcon';
import { AuthIllustration } from '../../assets/illustration';
import { Link, useLocation, Navigate } from 'react-router-dom';
import { APP_URLS } from '../../routes/urls';
import { VerificationLocationState } from './types';
import { ResendActivationProvider } from '../../containers/resend-activation-provider/ResendActivationProvider';
import LoadingButton from '@mui/lab/LoadingButton';
import { verificationPageStyles } from './styles';
import { BreadcrumbLink } from '../../components/breadcrumb/Breadcrumb';
import { useUpdateBreadcrumb } from '../../hooks/useUpdateBreadcrumb';

const breadcrumbLinks: BreadcrumbLink[] = [
  { label: 'Create Account', href: APP_URLS.signUp },
  { label: 'Account Verfication' },
];

export const VerificationPage: React.FC = () => {
  const location = useLocation();
  const state = location.state as VerificationLocationState;
  useUpdateBreadcrumb(breadcrumbLinks);

  if (!state?.email) {
    return <Navigate to={APP_URLS.signIn} replace />;
  }

  return (
    <Box sx={{ py: 7.5 }} className="container-fluid">
      <Grid container justifyContent="center">
        <Grid item>
          <Box sx={verificationPageStyles.card}>
            <Box>
              <AppIcon Icon={AuthIllustration} sx={verificationPageStyles.svg} />
            </Box>
            <ResendActivationProvider showResendActivationButton={false} email={state?.email}>
              {({ loading, renderMessage, resendActivation, isAccountAlreadyActivated }) => (
                <>
                  <Typography paragraph variant="large" sx={verificationPageStyles.title}>
                    Congratulation, your account has been created. Click the link on your email for account
                    verification.
                  </Typography>
                  <Box sx={{ textAlign: 'left' }}>{renderMessage()}</Box>
                  <Grid container justifyContent="center" spacing={2.5}>
                    <Grid item>
                      <Button variant="contained" component={Link} to={APP_URLS.signIn}>
                        Goto Sign In
                      </Button>
                    </Grid>
                    {!isAccountAlreadyActivated && (
                      <Grid item>
                        <LoadingButton
                          loading={loading}
                          loadingIndicator="Re-sending link.."
                          variant="text"
                          onClick={resendActivation}
                        >
                          Re-send Verification Link
                        </LoadingButton>
                      </Grid>
                    )}
                  </Grid>
                </>
              )}
            </ResendActivationProvider>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};
